import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllInstagramReelPosts.graphql';
import { Query, QueryallInstagramReelPostsArgs } from '../../__generated__/globalTypes';

export const useAllInstagramReelPostsQuery = (options?: QueryHookOptions<Query, QueryallInstagramReelPostsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallInstagramReelPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllInstagramReelPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallInstagramReelPostsArgs>
): QueryResult<Query, QueryallInstagramReelPostsArgs> & {
  getAllInstagramReelPosts: LazyQueryExecFunction<Query, QueryallInstagramReelPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllInstagramReelPosts, result] = useLazyQuery<Query, QueryallInstagramReelPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllInstagramReelPosts, ...result };
};

export const useAllInstagramReelPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllInstagramReelPosts = useCallback(
    (options?: Omit<QueryOptions<QueryallInstagramReelPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallInstagramReelPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllInstagramReelPosts };
};
// Suspense Query Hooks
export const useAllInstagramReelPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallInstagramReelPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallInstagramReelPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
